module.exports = __webpack_public_path__ + "img/wallet_02_slick_2.a71be2e3.png";